var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { isValidElement, memo, useCallback } from 'react';
import cc from 'classcat';
/**
 *
 * @param props
 * @constructor
 */
var SingleSlide = function (props) {
    var index = props.index, slide = props.slide, current = props.current, disabled = props.disabled, onClick = props.onClick;
    var classList = cc(['horizontal-slider-btn', { 'date-tab-active': current }, { 'date-tab-disabled': disabled }]);
    var onButtonClick = useCallback(function () {
        // We also check on disabled here, since disabled on button doesn't work for onTouchEndCapture
        if (onClick && !disabled) {
            onClick(slide.id);
        }
    }, [slide, onClick]);
    return (React.createElement("button", { className: classList, type: "button", "data-tab-id": index, onClickCapture: onButtonClick, onTouchEndCapture: onButtonClick, disabled: disabled }, isValidElement(slide.content) ? React.createElement(React.Fragment, null, slide.content) : (React.createElement(slide.content, __assign({}, slide)))));
};
SingleSlide.defaultProps = {
    current: false,
    disabled: false,
    onClick: undefined,
};
export default memo(SingleSlide);
